import React from 'react';

import styled from '@emotion/styled';

// import LeftPart from './LeftPart';
import RightPart from './RightPart';

const ContactForm = () => {
  return (
    <Container>
      {/* <LeftPart /> */}
      <RightPart />
    </Container>
  );
};

export default ContactForm;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
    gap: 40px;
  }
`;
